<template>
  <div class="exhibitorMess">
    <div class="header">
      <div class="service_h">在线留言</div>
    </div>

    <div class="warning">
      <p>
        <img src="../../../assets/image/warning.png" alt />
        留言注意事项
      </p>
      <p>1.遵守中华人民共和国有关法律、法规，尊重网上道德，承担一切因您的行为而直接或间接引起的法律责任。</p>
      <p>2.请您真实的反映产品的情况，不要捏造、污蔑、造谣。如对产品有任何疑问，也可以留言咨询。</p>
      <p>3.未经本站同意，任何人不得利用本留言薄发布个人或团体的具有广澳性质的信息或类似言论。</p>
    </div>

    <div class="form_div">
      <el-form ref="messForm" :model="messForm" class="" label-width="92px" :rules="rules">
        <el-form-item label="您的姓名：" prop="name">
          <el-input v-model="messForm.name" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="您的性别：" prop="sex">
          <el-radio v-model="radio" label="0">男</el-radio>
          <el-radio v-model="radio" label="1">女</el-radio>
        </el-form-item>
        <el-form-item label="联系电话：" prop="phone">
          <el-input v-model="messForm.phone" placeholder="请填联系电话"></el-input>
        </el-form-item>
        <el-form-item label="常用邮箱：" prop="email">
          <el-input v-model="messForm.email" placeholder="请填您的常用邮箱"></el-input>
        </el-form-item>
        <el-form-item label="单位名称：" prop="company">
          <el-input v-model="messForm.company" placeholder="请填您的单位名称"></el-input>
        </el-form-item>
        <el-form-item label="验证码：" prop="code">
          <el-input v-model="messForm.code" class="code_inp" placeholder="请输入验证码"></el-input>
          <img class="uuImg" :src="captchaPath" @click="getCaptcha()" alt />
        </el-form-item>
        <el-form-item label="留言标题：" prop="title">
          <el-input v-model="messForm.title" placeholder="请填您留言的简介"></el-input>
        </el-form-item>
        <el-form-item label="留言内容：" prop="content">
          <el-input v-model="messForm.content" type="textarea" placeholder="请填您想要留言的内容..."></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button class="reset" @click="reset">重置</el-button>
          <el-button class="submit" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { getUUID } from "@/utils";
export default {
  props: ["exhibitorId"],
  data() {
    return {
      messForm: {
        name: "",
        sex: "",
        phone: "",
        email: "",
        company: "",
        code: "",
        title: "",
        content: ""
      },
      sessionAccID: null,
      radio: "0",
      captchaPath: "",
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        // sex: [
        //   { required: true, message: '请选择性别', trigger: 'blur' }
        // ],
        phone: [
          { required: true, message: '请填写联系电话', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请填写常用邮箱', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写验证码', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '请填写留言标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请填写留言内容', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    let sessionAccountId = sessionStorage.getItem("accountId");
    this.sessionAccID = sessionAccountId * 1;
    this.getCaptcha();
  },
  methods: {
    // 获取验证码
    getCaptcha() {
      this.uuid = getUUID();
      this.captchaPath = this.$http.adornUrl(`/captcha.jpg?uuid=${this.uuid}`);
    },
    reset() {
      this.$refs["messForm"].resetFields();
    },
    submitForm() {
      this.$refs["messForm"].validate( (valid) => {
        if (valid) {
          this.$http({
            url: "saveLeaveMsg",
            method: "post",
            data: this.$http.adornData({
              accountId: this.sessionAccID,
              name: this.messForm.name,
              sex: this.radio,
              phone: this.messForm.phone,
              email: this.messForm.email,
              company: this.messForm.company,
              code: this.messForm.code,
              title: this.messForm.title,
              content: this.messForm.content,
              uuid: this.uuid
            })
          }).then( ({data}) => {
            let { code } = data;
            if (code === 0) {
              this.$message({
                message: '已收到您的留言',
                type: 'success',
                duration: 1000,
                onClose: () => {
                  this.reset()
                }
              })
            }
          })
        }
      })
    },
  }
};
</script>
<style lang="scss">
.exhibitorMess {
  .el-input {
    width: 624px;
    height: 42px;
  }
  .el-input__inner {
    border-radius: 4px;
    height: 42px;
  }
  .el-radio__inner {
    &:hover {
      border-color: #143372;
    }
  }
  .el-radio__input .el-radio__inner {
    width: 20px;
    height: 20px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    width: 20px;
    height: 20px;
    background-color: #ffffff;
    border: 2px solid #dcdfe6;
    border-color: #143372;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #000000;
  }
  .el-radio__inner::after {
    width: 12px;
    height: 12px;
    background-color: #143372;
  }
  .el-textarea {
    height: 300px;
    .el-textarea__inner {
      height: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>
.exhibitorMess {
  width: 100%;
  height: 1161px;
  background-color: #ffffff;
  color: #333333;
  .header {
    width: 100%;
    height: 30px;
    line-height: 35px;
    margin-bottom: 55px;
    .service_h {
      width: 100px;
      height: 100%;
      float: left;
      font-size: 16px;
      color: #143372;
      border-top: 2px solid #143372;
      border-right: 1px solid #bbbbbb;
      text-align: center;
    }
  }
  .warning {
    width: 720px;
    height: 115px;
    margin-left: 43px;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    p:first-child {
      height: 20px;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 10px;
      img {
        margin-right: 10px;
      }
    }
  }
  .form_div {
    width: 720px;
    margin: 80px 0 0 43px;
    .uuImg {
      width: 121px;
      height: 42px;
    }
    .code_inp {
      width: 484px;
      margin-right: 20px;
    }
    .btns {
      margin-top: 70px;
      text-align: right;
      font-size: 14px;
      .reset {
        width: 62px;
        height: 36px;
        color: #333333;
        background-color: #e5e5e5;
        line-height: 0;
        padding: 12px 16px;
        &:hover {
          border-color: #e5e5e5;
        }
        &:focus {
          border-color: #e5e5e5;
        }
      }
      .submit {
        width: 96px;
        height: 36px;
        color: #ffffff;
        background-color: #143372;
        line-height: 0;
      }
    }
  }
}
</style>